window.addEventListener('load', () => {
    changeTab();
});

function changeTab() {
    const tabsBlocks = document.querySelectorAll('.highlighted-product-block');

    tabsBlocks.forEach(tabsblock => {
        const tabs = tabsblock.querySelectorAll('.tabs-navigation .tab-button');
        const contents = tabsblock.querySelectorAll('.tab-content');
        const images = tabsblock.querySelectorAll('.image-wrapper .image-inner');

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                tabs.forEach(t => t.classList.remove('active'));
                contents.forEach(c => c.classList.remove('active'));
                images.forEach(i => i.classList.remove('active'));

                tab.classList.add('active');
                contents[index].classList.add('active');
                images[index].classList.add('active');
            });
        });
    });
}